var $ = require('jquery');
import noUiSlider from 'nouislider';


if ($('.dd-filter__select-item').length) {

  $('.dd-filter__select-item').each(function () {
    let $self = $(this);

    $self.find('.dd-filter__title').on('click', function (event) {
      if ($self.hasClass('is-active')) {
        $self.removeClass('is-active');
      } else {
        $('.dd-filter__select-item').removeClass("is-active");
        $self.addClass('is-active');
      }
    });
  });

  var rangeSliderContainer = document.getElementById('dd-filter__range-slider');

  noUiSlider.create(rangeSliderContainer, {
      start: [1000, 10000],
      connect: true,
      range: {
          'min': 0,
          'max': 30000
      }
  });


  var inputNumberMin = document.getElementById('dd-form-slider-min');
  var inputNumberMax = document.getElementById('dd-form-slider-max');

  rangeSliderContainer.noUiSlider.on('update', function (values, handle) {

      var value = values[handle];

      if (handle) {
          inputNumberMin.value = value;
      }
      else {
          inputNumberMax.value = value;
      }
  });

  inputNumberMin.addEventListener('change', function () {
      rangeSliderContainer.noUiSlider.set([null, this.value]);
  });

  inputNumberMax.addEventListener('change', function () {
      rangeSliderContainer.noUiSlider.set([null, this.value]);
  });
}